import RsvpSeatplanElements from '../../../store/seatplans/rse/index';

angular
    .module('festzelt-os.seatplans')
    .factory('RsvpSeatplansElements', [
        '$injector',
        'RsvpSeatplanElement',
        ($injector, RsvpSeatplanElement) => new RsvpSeatplanElements(RsvpSeatplanElement, {
            injector: $injector
        })
    ]);



// WEBPACK FOOTER //
// ./src/app/pages/seatplans/store/rse.js